import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { PositivePayCheckFile } from "model";
/**
* @class PositivePayCheck
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _id - The id of the positive pay check template.
* @extends BCMSRecord
* @example const record = model.positivePayCheckTemplates[0];
* const template = new PositivePayCheckTemplate(record);
*/
export default class PositivePayCheckTemplate extends BCMSRecord {
    _id
    _positivePayCheckFile
    _importAttachedFile
    _name
    _inputDecimalsIntoAmount
    _numberOfRowsToExcludeHeader
    _numberOfRowsToExcludeFooter
    _textQualified 
    _fileFormatDelimited 
    _fileFormatFixedWidth
    _fileFormatDelimitedType
    _useCustomTransactionCode
    _mapColumn1 
    _mapColumn2 
    _mapColumn3 
    _mapColumn4
    _mapColumn5 
    _mapColumn6 
    _mapColumn7 
    _mapColumn8
    _itemTypeMappingIssue 
    _itemTypeMappingStop 
    _itemTypeMappingVoid
    _customItemTypeCodes

    constructor(record) {     
      super(record) 
    }
  }
  PositivePayCheckTemplate.define({
    "recordType": "positivePayCheckTemplates",
    "recordIDProp":"id",
    "className" : "PositivePayCheckTemplate",
    "recordProperties":[

    /** 
     * @name id
     * @instance
     * @property get {STRING} - gets the id 
     * @property set {STRING} - sets the id 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("id","_id"),

    /** 
     * @name positivePayCheckFile
     * @instance
     * @property get {STRING} - gets the positivePayCheckFile 
     * @property set {STRING} - sets the positivePayCheckFile 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToClass("positivePayCheckFile","_positivePayCheckFile", () => PositivePayCheckFile),

    /** 
     * @name importAttachedFile
     * @instance
     * @property get {STRING} - gets the importAttachedFile 
     * @property set {STRING} - sets the importAttachedFile 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("importAttachedFile","_importAttachedFile"),
    
    /** 
     * @name name
     * @instance
     * @property get {STRING} - gets the name 
     * @property set {STRING} - sets the name 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("name","_name"),

    /** 
     * @name inputDecimalsIntoAmount
     * @instance
     * @property get {STRING} - gets the inputDecimalsIntoAmount 
     * @property set {STRING} - sets the inputDecimalsIntoAmount 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("inputDecimalsIntoAmount","_inputDecimalsIntoAmount"),

    /** 
     * @name numberOfRowsToExcludeHeader
     * @instance
     * @property get {STRING} - gets the numberOfRowsToExcludeHeader 
     * @property set {STRING} - sets the numberOfRowsToExcludeHeader 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("numberOfRowsToExcludeHeader","_numberOfRowsToExcludeHeader"),

    /** 
     * @name numberOfRowsToExcludeFooter
     * @instance
     * @property get {STRING} - gets the numberOfRowsToExcludeFooter 
     * @property set {STRING} - sets the numberOfRowsToExcludeFooter 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("numberOfRowsToExcludeFooter","_numberOfRowsToExcludeFooter"),

    /** 
     * @name textQualified
     * @instance
     * @property get {STRING} - gets the textQualified 
     * @property set {STRING} - sets the textQualified 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("textQualified","_textQualified"),

    /** 
     * @name fileFormatDelimited
     * @instance
     * @property get {STRING} - gets the fileFormatDelimited 
     * @property set {STRING} - sets the fileFormatDelimited 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("fileFormatDelimited","_fileFormatDelimited"),

    /** 
     * @name fileFormatFixedWidth
     * @instance
     * @property get {STRING} - gets the fileFormatFixedWidth 
     * @property set {STRING} - sets the fileFormatFixedWidth 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("fileFormatFixedWidth","_fileFormatFixedWidth"),

    /** 
     * @name fileFormatDelimitedType
     * @instance
     * @property get {STRING} - gets the fileFormatDelimitedType 
     * @property set {STRING} - sets the fileFormatDelimitedType 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("fileFormatDelimitedType","_fileFormatDelimitedType"),

    /** 
     * @name useCustomTransactionCode
     * @instance
     * @property get {STRING} - gets the fileFormatDelimitedType 
     * @property set {STRING} - sets the fileFormatDelimitedType 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("useCustomTransactionCode","_useCustomTransactionCode"),

    /** 
     * @name mapColumn1
     * @instance
     * @property get {STRING} - gets mapColumn1 
     * @property set {STRING} - sets mapColumn1 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn1","_mapColumn1"),

    /** 
     * @name mapColumn2
     * @instance
     * @property get {STRING} - gets mapColumn2 
     * @property set {STRING} - sets mapColumn2 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn2","_mapColumn2"),

    /** 
     * @name mapColumn3
     * @instance
     * @property get {STRING} - gets mapColumn3 
     * @property set {STRING} - sets mapColumn3 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn3","_mapColumn3"),

    /** 
     * @name mapColumn4
     * @instance
     * @property get {STRING} - gets mapColumn4 
     * @property set {STRING} - sets mapColumn4 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn4","_mapColumn4"),

    /** 
     * @name mapColumn5
     * @instance
     * @property get {STRING} - gets mapColumn5 
     * @property set {STRING} - sets mapColumn5 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn5","_mapColumn5"),

    /** 
     * @name mapColumn6
     * @instance
     * @property get {STRING} - gets mapColumn6 
     * @property set {STRING} - sets mapColumn6 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn6","_mapColumn6"),

    /** 
     * @name mapColumn7
     * @instance
     * @property get {STRING} - gets mapColumn7 
     * @property set {STRING} - sets mapColumn7 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn7","_mapColumn7"),

    /** 
     * @name mapColumn8
     * @instance
     * @property get {STRING} - gets mapColumn8 
     * @property set {STRING} - sets mapColumn8 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("mapColumn8","_mapColumn8"),

    /** 
     * @name itemTypeMappingIssue
     * @instance
     * @property get {STRING} - gets itemTypeMappingIssue 
     * @property set {STRING} - sets itemTypeMappingIssue 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("itemTypeMappingIssue","_itemTypeMappingIssue"),

    /** 
     * @name itemTypeMappingStop
     * @instance
     * @property get {STRING} - gets itemTypeMappingStop 
     * @property set {STRING} - sets itemTypeMappingStop 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("itemTypeMappingStop","_itemTypeMappingStop"),

    /** 
     * @name itemTypeMappingVoid
     * @instance
     * @property get {STRING} - gets itemTypeMappingVoid 
     * @property set {STRING} - sets itemTypeMappingVoid 
     * @memberof PositivePayCheckTemplate
     */
    BCMSRecordProperty.mapToString("itemTypeMappingVoid","_itemTypeMappingVoid"),

    /**
     * @name customItemTypeCodes
     * @instance
     * @property get {ARRAY} - gets the _denyAccessToACHTemplateIDs
     * @property set {ARRAY} - sets the _denyAccessToACHTemplateIDs
     * @note The mapToArray currently does not work correctly when the toRecord function is called
     * @memberof ACHTemplate
     */
    BCMSRecordProperty.mapTo({
        id: "customItemTypeCodes",
        instanceField: "_customItemTypeCodes",
        setter: function(value) {
          if(value === undefined || Array.isArray(value)) {
            this._customItemTypeCodes = value;
          } else {
            this._customItemTypeCodes = value === "" ? [] : value.split(",");
          }
        },
        toRecord: function() {
            return this._customItemTypeCodes === undefined || this._customItemTypeCodes.length === 0
                ? ""
                : this._customItemTypeCodes.reduce((result, item) => `${ result },${ item }`);
        }
    }),
]
  
})




